export enum EOnboardingTaskState {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  Completed = 'completed',
  Skipped = 'skipped',
}

export enum EOnboardingTaskType {
  AuthenticateDomain = 'AuthenticateDomainTask',
  BuildFirstGroup = 'BuildFirstGroupTask',
  CreateFirstProject = 'CreateFirstProjectTask',
  InviteOtherUsers = 'InviteOtherUsersTask',
  SetupBilling = 'SetupBillingTask',
  SetupSuperPixel = 'SetupSuperPixelTask',
  CreateEmailTemplate = 'CreateEmailTemplateTask',
  ImportEmailData = 'ImportEmailDataTask',
  PublishFirstEmailCampaign = 'PublishFirstEmailCampaignTask',
  PublishFirstAdCampaign = 'PublishFirstAdCampaignTask',
}

// Each task inherits from the OnboardingTask class.
export enum EOnboardingTaskTypeClass {
  AuthenticateDomain = 'OnboardingTask.AuthenticateDomainTask',
  BuildFirstGroup = 'OnboardingTask.BuildFirstGroupTask',
  CreateFirstProject = 'OnboardingTask.CreateFirstProjectTask',
  InviteOtherUsers = 'OnboardingTask.InviteOtherUsersTask',
  SetupBilling = 'OnboardingTask.SetupBillingTask',
  SetupSuperPixel = 'OnboardingTask.SetupSuperPixelTask',
  CreateEmailTemplate = 'OnboardingTask.CreateEmailTemplateTask',
  ImportEmailData = 'OnboardingTask.ImportEmailDataTask',
  PublishFirstEmailCampaign = 'OnboardingTask.PublishFirstEmailCampaignTask',
  PublishFirstAdCampaign = 'OnboardingTask.PublishFirstAdCampaignTask',
}

export enum EOnboardingMilestone {
  InitialAccountSetup = 'initial_account_setup',
  SingleSendCampaign = 'single_send_campaign',
  RetargetingCampaign = 'retargeting_campaign',
}
